import { render, staticRenderFns } from "./MarkedOffRefrenceList.vue?vue&type=template&id=2f9e3677&"
import script from "./MarkedOffRefrenceList.vue?vue&type=script&lang=js&"
export * from "./MarkedOffRefrenceList.vue?vue&type=script&lang=js&"
import style0 from "./MarkedOffRefrenceList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports